const questionTypeMap: Record<QuestionType, string> = {
    38: '객관식', //'단일선택형',
    39: '객관식', //'다중선택형',
    40: '주관식', //'단답형',
    41: '서술형',
    42: '객관식', //'연결형',
    43: '객관식', //'TF형',
    44: '주관식', //'순서 입력형',
    45: '주관식', //'순서 조합형',
    46: '연쇄형',
    354: '객관식', //'OX형',
    36504: '발음평가형',
    41559: '녹음/녹화형',
    41769: '조작형 활동',
    43386: '그리기형',
    58081: 'AI 첨삭 활동형',
    58085: '초성퀴즈형',
} as const;

const questionMap: Record<QuestionType, string> = {
    38: '단일선택형',
    39: '다중선택형',
    40: '단답형',
    41: '서술형',
    42: '연결형',
    43: 'TF형',
    44: '순서 입력형',
    45: '순서 조합형',
    46: '연쇄형',
    354: 'OX형',
    36504: '발음평가형',
    41559: '녹음/녹화형',
    41769: '조작형 활동',
    43386: '그리기형',
    58081: 'AI 첨삭 활동형',
    58085: '초성퀴즈형',
} as const;

export const getQuestionTypeName = (questionType: QuestionType): string => {
    return questionTypeMap[questionType] || '알 수 없는 유형';
};

export const getQuestionTypeCode = (label: string): QuestionType | undefined => {
    const entry = Object.entries(questionMap).find(([_, value]) => value === label);
    return entry ? (Number(entry[0]) as QuestionType) : undefined;
};

export const getConvertQuestionName = (questionTypeName: string): string => {
    const toType = (name: string): string =>
        ['단일선택형', '다중선택형', 'TF형', 'T/F형', '연결형', 'OX형'].includes(name)
            ? '객관식'
            : ['단답형', '순서 입력형', '순서 조합형', '자유단답형'].includes(name)
              ? '주관식'
              : name === '서술형'
                ? '서술형'
                : name;

    const priority: Record<string, number> = {
        객관식: 1,
        주관식: 2,
        서술형: 3,
    };

    const compareByPriority = (a: string, b: string) => (priority[a] ?? 999) - (priority[b] ?? 999);

    if (questionTypeName && questionTypeName.includes(',')) {
        const types = questionTypeName
            .split(',')
            .map((name) => toType(name.trim()))
            .filter(Boolean);

        const uniqueSorted = [...new Set(types)].sort(compareByPriority);
        return uniqueSorted.join(',');
    }

    return toType(questionTypeName ? questionTypeName.trim() : '');
};
